import React, { useEffect, useState } from 'react';
import './HeroSection.css';

const HeroSection = () => {
    const [bgImage, setBgImage] = useState('assets/studyabroad/studyabrooad-empty.png');

    useEffect(() => {
        console.log('loaded');
        
    }, []);

    const style = {
        backgroundImage: `url(${bgImage})`,
    };

    return (
        <div id='hero' className="hero-container" style={style}>
            <div className="overlay"></div>
            <div className="hero-content" >
                <h1>Start Your Study Abroad Journey</h1>
                <p>Explore top universities across the globe.</p>
                <button className="cta-button">Get Started</button>
            </div>
        </div>
    );
}

export default HeroSection;
